export const COLOR_SUCCESS = 'success'
export const COLOR_ERROR = 'error'

export const THEME_MODE = {
  DARK: 'dark',
  LIGHT: 'light'
}
